import { createSemanticMetrics, createUniversalReporter, } from '@spotify-internal/semantic-metrics';
const { sendMetric } = createSemanticMetrics({
    key: 'oauth-silent-authentication',
    reporter: createUniversalReporter(),
});
const defaultTags = { version: process.env.npm_package_version || '' };
export { sendMetric, defaultTags };
export var MetricActions;
(function (MetricActions) {
    MetricActions["FETCH_AUTHORIZED"] = "fetch-authorized";
    MetricActions["ACCESS_TOKEN_ERROR"] = "access-token-error";
    MetricActions["INTERACTIVE_LOGIN"] = "interactive-login";
    MetricActions["INTERACTIVE_LOGOUT"] = "interactive-logout";
    MetricActions["AUTH_CODE_ERROR"] = "user-id-error";
})(MetricActions || (MetricActions = {}));
//# sourceMappingURL=metricsHelper.js.map